import React from "react";
import { Box, Button } from "@mui/material";
import { COLORS } from "../../styles/uiConstants";
import SegmentedControl from "../atoms/SegmentedControl";

const PERIODS = [
  { value: "today", label: "Bugün" },
  { value: "this_week", label: "Bu Hafta" },
  { value: "this_month", label: "Bu Ay" },
  { value: "last_30_days", label: "Son 30 Gün" },
];

/** Dashboard panellerinde kullanılan dönem seti (yesterday + this_year dahil). */
export const DASHBOARD_PERIODS = [
  { value: "today", label: "Bugün" },
  { value: "yesterday", label: "Dün" },
  { value: "this_week", label: "Bu Hafta" },
  { value: "this_month", label: "Bu Ay" },
  { value: "this_year", label: "Bu Yıl" },
];

/**
 * Dönem seçici.
 *
 * @param {string} value - Seçili dönem
 * @param {Function} onChange
 * @param {object} [palette] - useClinicTheme() palette
 * @param {Array<{value: string, label: string}>} [options] - Dönem listesi
 * @param {"buttons"|"segmented"} [variant] - "buttons" (varsayılan) ayrı ayrı
 *   outlined butonlar; "segmented" tek çerçeve içinde bitişik pill grubu.
 * @param {boolean} [isLoading] - segmented varyantta iskelet gösterir
 */
export default function PeriodSelector({
  value,
  onChange,
  palette,
  options = PERIODS,
  variant = "buttons",
  isLoading = false,
}) {
  if (variant === "segmented") {
    return (
      <SegmentedControl
        value={value}
        onChange={onChange}
        options={options}
        palette={palette}
        isLoading={isLoading}
        ariaLabel="Dönem"
        sx={{ display: "flex" }}
      />
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {options.map((p) => (
        <Button
          key={p.value}
          size="small"
          variant={value === p.value ? "contained" : "outlined"}
          onClick={() => onChange(p.value)}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            fontSize: 12,
            borderRadius: 2,
            px: 2,
            py: 0.5,
            ...(value === p.value
              ? {
                  bgcolor: palette?.primary || COLORS.slate800,
                  color: "#fff",
                  "&:hover": { bgcolor: palette?.primary || COLORS.slate700 },
                }
              : {
                  borderColor: COLORS.slate300,
                  color: COLORS.slate600,
                  "&:hover": { borderColor: COLORS.slate400, bgcolor: COLORS.slate50 },
                }),
          }}
        >
          {p.label}
        </Button>
      ))}
    </Box>
  );
}
